import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { getSiteConfig, getSiteLanguages } from './config/sites';

export { LANGUAGE_NAMES, RTL_LANGUAGES } from './config/sites';

/**
 * Los idiomas dependen del sitio (Definicion 35):
 * jeshua.ong y jeshua.es ofrecen los 33 idiomas; jeshua.cl ofrece 2 (espanol y portugues).
 * La lista real es la de config/sites.js filtrada por los idiomas ya traducidos.
 */
const siteConfig = getSiteConfig();

const isLocalHost = ['localhost', '127.0.0.1'].includes(window.location.hostname);
const loadPath = (lngs, namespaces) =>
  isLocalHost ? '/locales/{{lng}}/{{ns}}.json' : '/i18n/{{lng}}/{{ns}}.json';

export const SUPPORTED_LANGUAGES = getSiteLanguages(siteConfig);

/* 🔴 EL REPUESTO TIENE QUE EXISTIR (28-ago). `fallbackLng` era el idioma por
   defecto del dominio —en jeshua.ong, el ingles—, y desde que solo se ofrecen
   los idiomas traducidos ese repuesto puede NO ESTAR entre ellos. Cuando eso
   pasa, i18next no carga textos para nadie y la web sale con las claves crudas
   a la vista: «fun.titulo», «home.frase». Rompio el sitio entero, y en
   produccion le habria pasado a todo visitante con un idioma guardado de antes.
   El repuesto se elige ahora entre los que SI se sirven. */
const REPUESTO = SUPPORTED_LANGUAGES.includes(siteConfig.defaultLanguage)
  ? siteConfig.defaultLanguage
  : (SUPPORTED_LANGUAGES[0] || 'es');

/* Y si el visitante traia guardado un idioma que ya no se sirve, se limpia:
   si no, el detector lo volveria a elegir en cada visita. */
try {
  const guardado = window.localStorage.getItem('jeshua_lang');
  if (guardado && !SUPPORTED_LANGUAGES.includes(guardado)) {
    window.localStorage.removeItem('jeshua_lang');
  }
} catch (e) { /* navegador sin almacenamiento: seguimos */ }

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: REPUESTO,
    lng: REPUESTO,
    supportedLngs: SUPPORTED_LANGUAGES,
    ns: ['common'],
    defaultNS: 'common',
    backend: {
      loadPath
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: [],
      lookupLocalStorage: 'jeshua_lang'
    },
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
